import Datepicker from 'vuejs-datepicker';
import lang from "@/views/modules/ExpressionInterests/language/en";
import Editor from '@tinymce/tinymce-vue';
import alert from "@/views/shared/notify/Alert.vue";
import SelectFile from "@/components/layout/shared/generic/common/SelectFile.vue";

export default {
    name: "new-opportunity",
 
    components: {
        Datepicker,
        'editor': Editor,
        alert,
        SelectFile
    },
    data() {
        return {
            loading: true,
            formData: {},
            lang:[],
            process:false,
        }
    },
    mounted() {
       
        this.lang = lang;
        this.formData = {
            parent_type:'opportunitys',
            opportunity_id:this.$route.query.opportunity_id
        }
        document.getElementById("opportunity_title").value=this.$route.query.titile;
        let current_date = localStorage.getItem('current_date');
        let date_arr = current_date.split(" ");
        this.formData.submited_on = this.$date.parse(date_arr[0]);
        this.checkEOI();
        this.setEOIBy();
    },
    methods: {
        saveEOI() {
            const self = this;
            self.loading = true;
            self.process = true;
            axios.post('api/modules/exinterests', self.formData).then(function (response) {
                self.loading = false;
                self.process = false;
                self.$router.push('/modules/exinterests');
            }).catch(function () {
                self.loading = false;
                self.process = false;
                let allerror = document.getElementsByClassName('error');
                        for(let i = 0; i < allerror.length; i++)
                        {
                            allerror[i].innerHTML = '';
                        }
                        let err = localStorage.getItem('Errors');
                        let err_msg = (JSON.parse(err));
                        let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                        Object.keys(err_msg2 || {}).forEach((key) => {
                            let errorval = err_msg2[key];
                           
                            let error_el = document.getElementById(key+"_error");
                                error_el.innerHTML = errorval
                        });
                        localStorage.removeItem('Errors');
            });
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },
        setEOIBy(){
            const self = this; 
            let userData = localStorage.getItem('user_prefrence');
            let users = JSON.parse(userData);
            
            self.formData.eoi_by = users.name;
        },
        checkEOI(){
            const self = this;
            let opp_date = {'opp_id':self.$route.query.opportunity_id};
             axios.post('api/modules/exinterests/getopportunity', opp_date).then(function (response) {
                 if(response.data.message == ''){
                    
                 }else{
                   self.$refs.notifyMsg.showAlert('Error',response.data.message);
                   self.$router.push(`/modules/exinterests`);
                 }
                
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            }); 
        }
    }
}